import {createContext} from "react";

export const LogsContext = createContext({
    itemType: "",
    itemId: "",
    selectedItemIdentifier: "",
    selectedItemBarcode: "",
    isManualSelection: false,
    itemList: [],
    setIsManualSelection: () => {},
    seeItemLog: () => {},
})